"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zipCodeUpdate = exports.veteranUpdate = exports.stateListUpdate = exports.stateCountyUpdate = exports.stateCountyNameUpdate = exports.propertyUsedUpdate = exports.propertyTypeUpdate = exports.lowRatesUpdate = exports.lowRatesOptionUpdate = exports.loanBalanceUpdate = exports.loanAmountTotalUpdate = exports.estimatedValueUpdate = exports.estimatedHomeValueUpdate = exports.countryStateUpdate = exports.cashoutAmountUpdate = exports.TypeSelected = exports.ShowButtons = exports.PurchasePriceUpdate = exports.DownPaymentInUSDsUpdate = exports.DownPaymentInPercentsUpdate = exports.CreditScoreUpdate = void 0;
const TypeSelected = inputValue => {
  return {
    type: 'TYPESELECTED',
    payload: inputValue
  };
};
exports.TypeSelected = TypeSelected;
const PurchasePriceUpdate = inputValue => {
  return {
    type: 'PURCHASEPRICEUPDATE',
    payload: inputValue
  };
};
exports.PurchasePriceUpdate = PurchasePriceUpdate;
const DownPaymentInUSDsUpdate = inputValue => {
  return {
    type: 'DOWNPAYMENTINUSDSUPDATE',
    payload: inputValue
  };
};
exports.DownPaymentInUSDsUpdate = DownPaymentInUSDsUpdate;
const DownPaymentInPercentsUpdate = inputValue => {
  return {
    type: 'DOWNPAYMENTINPERCENTSSUPDATE',
    payload: inputValue
  };
};
exports.DownPaymentInPercentsUpdate = DownPaymentInPercentsUpdate;
const CreditScoreUpdate = inputValue => {
  return {
    type: 'CREDITSCOREUPDATE',
    payload: inputValue
  };
};
exports.CreditScoreUpdate = CreditScoreUpdate;
const ShowButtons = inputValue => {
  return {
    type: 'SHOWBUTTONSUPDATE',
    payload: inputValue
  };
};
exports.ShowButtons = ShowButtons;
const propertyTypeUpdate = inputValue => {
  return {
    type: 'PROPERTYTYPEUPDATE',
    payload: inputValue
  };
};
exports.propertyTypeUpdate = propertyTypeUpdate;
const propertyUsedUpdate = inputValue => {
  return {
    type: 'PROPERTYUSEDUPDATE',
    payload: inputValue
  };
};
exports.propertyUsedUpdate = propertyUsedUpdate;
const lowRatesUpdate = inputValue => {
  return {
    type: 'LOWRATESUPDATE',
    payload: inputValue
  };
};
exports.lowRatesUpdate = lowRatesUpdate;
const lowRatesOptionUpdate = inputValue => {
  return {
    type: 'LOWRATESOPTION',
    payload: inputValue
  };
};
exports.lowRatesOptionUpdate = lowRatesOptionUpdate;
const estimatedValueUpdate = inputValue => {
  return {
    type: 'ESTIMATEDVALUEUPDATED',
    payload: inputValue
  };
};
exports.estimatedValueUpdate = estimatedValueUpdate;
const loanBalanceUpdate = inputValue => {
  return {
    type: 'LOANBALANCEUPDATED',
    payload: inputValue
  };
};
exports.loanBalanceUpdate = loanBalanceUpdate;
const cashoutAmountUpdate = inputValue => {
  return {
    type: 'CASHOUTAMOUNTUPDATED',
    payload: inputValue
  };
};
exports.cashoutAmountUpdate = cashoutAmountUpdate;
const estimatedHomeValueUpdate = inputValue => {
  return {
    type: 'ESTIMATEDHOMEVALUEUPDATED',
    payload: inputValue
  };
};
exports.estimatedHomeValueUpdate = estimatedHomeValueUpdate;
const loanAmountTotalUpdate = inputValue => {
  return {
    type: 'LOANAMOUNTTOTALUPDATE',
    payload: inputValue
  };
};
exports.loanAmountTotalUpdate = loanAmountTotalUpdate;
const zipCodeUpdate = inputValue => {
  return {
    type: 'ZIPCODEUPDATE',
    payload: inputValue
  };
};
exports.zipCodeUpdate = zipCodeUpdate;
const countryStateUpdate = inputValue => {
  return {
    type: 'COUNTRYSTATEUPDATE',
    payload: inputValue
  };
};
exports.countryStateUpdate = countryStateUpdate;
const stateCountyUpdate = inputValue => {
  return {
    type: 'STATECOUNTYUPDATE',
    payload: inputValue
  };
};
exports.stateCountyUpdate = stateCountyUpdate;
const stateCountyNameUpdate = inputValue => {
  return {
    type: 'STATECOUNTYNAMEUPDATE',
    payload: inputValue
  };
};
exports.stateCountyNameUpdate = stateCountyNameUpdate;
const veteranUpdate = inputValue => {
  return {
    type: 'VETERANUPDATE',
    payload: inputValue
  };
};
exports.veteranUpdate = veteranUpdate;
const stateListUpdate = inputValue => {
  return {
    type: 'STATELISTUPDATE',
    payload: inputValue
  };
};
exports.stateListUpdate = stateListUpdate;